// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.author-name {
    font-size: 1.4rem;
    font-weight: bold;
    width: 100%;
    height: 2.2rem;
    color: black;
    text-transform: none;
}

.author-name.dropdown-toggle {
    line-height: 0;
}

.author-name.client-message-type {
    text-align: right;
    border-radius: 2px;
    padding-right: .4rem;
    background: linear-gradient(to right, rgba(65, 191, 255, 0), rgba(38, 166, 154, 0.12), #26a69aa1);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    direction: rtl;
}

.author-name.operator-message-type {
    text-align: left;
    border-radius: 2px;
    padding-left: .4rem;
    margin-bottom: 6px;
    background: linear-gradient(to right, #2633a6a1, rgba(233, 233, 255, 0.5), rgba(38, 51, 166, 0));
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.author-name.operator-message-type.bot-message
{  
    background: linear-gradient(to right, #a62626a1, rgba(255, 233, 233, 0.5), rgba(166, 38, 38, 0));
}

.author-name.chat-info-messageType {
    min-width: 100% !important;
    height: 2rem;
    background-color: rgb(185, 196, 196);
    font-size: 1rem;
    margin-top: 1rem;
    display: inline-table;
}

.author-name__dropdown-actions {
    display: flex;
    flex-direction: column;
    top: 0rem !important;
    left: 0rem !important;
    z-index: 1000;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 0px 2px 0px #26a69a;
    border-radius: 2px;
    text-align: center;
}

.dropdown-actions__closed {
    visibility: hidden;
    opacity: 0;
}

.author-name__action {
    font-size: 1.2rem;
    font-weight: 500;
    padding: 1rem;
    line-height: 0;
    height: 1.8rem;
    background: none;
    color: black;
    box-shadow: 0px 1px 2px 1px #000000;
}

.author-name__action:hover {
    background: #26a69a;
    color: #fff;
}

.author-name__action:focus {
    background: #26a69a;
    color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/chats-panel/MessageItem/AuthorName/AuthorName.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,iGAAiG;IACjG,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gGAAgG;IAChG,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,gGAAgG;AACpG;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,oCAAoC;IACpC,mCAAmC;IACnC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf","sourcesContent":[".author-name {\r\n    font-size: 1.4rem;\r\n    font-weight: bold;\r\n    width: 100%;\r\n    height: 2.2rem;\r\n    color: black;\r\n    text-transform: none;\r\n}\r\n\r\n.author-name.dropdown-toggle {\r\n    line-height: 0;\r\n}\r\n\r\n.author-name.client-message-type {\r\n    text-align: right;\r\n    border-radius: 2px;\r\n    padding-right: .4rem;\r\n    background: linear-gradient(to right, rgba(65, 191, 255, 0), rgba(38, 166, 154, 0.12), #26a69aa1);\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    direction: rtl;\r\n}\r\n\r\n.author-name.operator-message-type {\r\n    text-align: left;\r\n    border-radius: 2px;\r\n    padding-left: .4rem;\r\n    margin-bottom: 6px;\r\n    background: linear-gradient(to right, #2633a6a1, rgba(233, 233, 255, 0.5), rgba(38, 51, 166, 0));\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.author-name.operator-message-type.bot-message\r\n{  \r\n    background: linear-gradient(to right, #a62626a1, rgba(255, 233, 233, 0.5), rgba(166, 38, 38, 0));\r\n}\r\n\r\n.author-name.chat-info-messageType {\r\n    min-width: 100% !important;\r\n    height: 2rem;\r\n    background-color: rgb(185, 196, 196);\r\n    font-size: 1rem;\r\n    margin-top: 1rem;\r\n    display: inline-table;\r\n}\r\n\r\n.author-name__dropdown-actions {\r\n    display: flex;\r\n    flex-direction: column;\r\n    top: 0rem !important;\r\n    left: 0rem !important;\r\n    z-index: 1000;\r\n    background-color: rgb(255, 255, 255);\r\n    box-shadow: 0px 0px 2px 0px #26a69a;\r\n    border-radius: 2px;\r\n    text-align: center;\r\n}\r\n\r\n.dropdown-actions__closed {\r\n    visibility: hidden;\r\n    opacity: 0;\r\n}\r\n\r\n.author-name__action {\r\n    font-size: 1.2rem;\r\n    font-weight: 500;\r\n    padding: 1rem;\r\n    line-height: 0;\r\n    height: 1.8rem;\r\n    background: none;\r\n    color: black;\r\n    box-shadow: 0px 1px 2px 1px #000000;\r\n}\r\n\r\n.author-name__action:hover {\r\n    background: #26a69a;\r\n    color: #fff;\r\n}\r\n\r\n.author-name__action:focus {\r\n    background: #26a69a;\r\n    color: #fff;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
